import FunctionHeader from "presentation/components/Header/FunctionHeader";
import Spinner from "presentation/components/Shared/Spinner";
import TimesheetForm from "presentation/components/Timesheet/TimesheetForm";
import usePermissionCheck from "presentation/hooks/use-check-permissions";

interface TimesheetFormPageProps {
  children?: React.ReactNode;
  isDisable?: boolean; // Adicionamos a prop isDisable
}

const TimesheetFormPage: React.FC<TimesheetFormPageProps> = ({
  children,
  isDisable,
}) => {
  const { isLoading } = usePermissionCheck({ requiredFunction: "timesheets" });

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <div>
      <FunctionHeader title="Mapa de Horas" />
      <TimesheetForm isDisable={isDisable || false} />
    </div>
  );
};

export default TimesheetFormPage;
